import { render, staticRenderFns } from "./EventRow.vue?vue&type=template&id=39cdef14&scoped=true&"
import script from "./EventRow.vue?vue&type=script&lang=ts&"
export * from "./EventRow.vue?vue&type=script&lang=ts&"
import style0 from "./EventRow.vue?vue&type=style&index=0&id=39cdef14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cdef14",
  null
  
)

export default component.exports